import { Input } from 'antd'

import Styled from './styled'

export default function MyInput(props) {
  const inputProps = {
    ...props,
  }

  return (
    <Styled className="input-component">
      <Input {...inputProps} />
    </Styled>
  )
}
